export const FETCH_ORGANIZATIONS_REQUEST = 'FETCH_ORGANIZATIONS_REQUEST';
export const FETCH_ORGANIZATIONS_RESOLVED = 'FETCH_ORGANIZATIONS_RESOLVED';
export const FETCH_ORGANIZATIONS_REJECTED = 'FETCH_ORGANIZATIONS_REJECTED';
export const FETCH_ORGANIZATION_RESOLVED = 'FETCH_ORGANIZATION_RESOLVED';
export const FETCH_ORGANIZATION_ADMINS_RESOLVED = 'FETCH_ORGANIZATION_ADMINS_RESOLVED';
export const EDIT_ADMIN = "EDIT_ADMIN";
export const CREATE_ADMIN = "CREATE_ADMIN";
export const CREATE_ORGANIZATIONS_REQUEST = 'CREATE_ORGANIZATIONS_REQUEST';
export const EDIT_ORGANIZATIONS_REQUEST = 'EDIT_ORGANIZATIONS_REQUEST';
